import React, { useEffect, useState } from "react"
import API from "../../api/axios"
import {
  Card,
  CardBody,
  CardHeader,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap"
import { ToastContainer, toast } from "react-toastify"
function Profile() {
  const [user, setUser] = useState(null)
  const [isEditing, setIsEditing] = useState(false)
  const [form, setForm] = useState({})

  const getUserProfile = async () => {
    try {
      const token = localStorage.getItem("authToken")
      const response = await API.get(
        "/users/profile",
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      setUser(response.data.user)
      setForm(response.data.user)
    } catch (error) {
      console.error("Error fetching profile", error)
    }
  }

  useEffect(() => {
    getUserProfile()
  }, [])

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleUpdate = () => {
    API
      .put(`api/users/profile/${user.id}`, form, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then(res => {
        setUser(res.data.user)
        setIsEditing(false)
        toast.success("Profile updated successfully ")
      })
      .catch(err => console.error(err))
  }

  if (!user) return <p>Loading...</p>

  return (
    <div className="container mt-4">
      <Card
        style={{
          borderRadius: "0px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <CardHeader
          style={{
            background: "#ffffffff",
            color: "#000",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          }}
        >
          <h4 className="mb-0">Welcome, {user.fname}</h4>
        </CardHeader>
        <CardBody>
          <div className="text-center mb-4">
            <div
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                backgroundColor: "#7A6FBE",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 10px",
                color: "#fff",
                fontSize: "36px",
                fontWeight: "bold",
                border: "4px solid #7A6FBE",
              }}
            >
              {`${user.fname?.[0]?.toUpperCase() || ""}${
                user.lname?.[0]?.toUpperCase() || ""
              }`}
            </div>

            <h5>
              {user.fname} {user.lname}
            </h5>
            <p className="text-muted">{user.email}</p>
          </div>

          {!isEditing ? (
            <>
              <Row className="text-center">
                <Col md={3}>
                  <div
                    style={{
                      background: "#f8f9fa",
                      padding: "15px",
                      borderRadius: "12px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <h6 style={{ fontWeight: "600", color: "#7A6FBE" }}>
                      📞Phone
                    </h6>
                    <p style={{ fontSize: "16px", margin: 0 }}>{user.phone}</p>
                  </div>
                </Col>
                <Col md={3}>
                  <div
                    style={{
                      background: "#f8f9fa",
                      padding: "15px",
                      borderRadius: "12px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <h6 style={{ fontSize: "600", color: "#7A6FBE" }}>
                      👤 Gender
                    </h6>
                    <p style={{ fontSize: "16px", margin: 0 }}>{user.gender}</p>
                  </div>
                </Col>
                <Col md={3}>
                  <div
                    style={{
                      background: "#f8f9fa",
                      padding: "15px",
                      borderRadius: "12px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <h6 style={{ fontSize: "600", color: "#7A6FBE" }}>
                      📍 Address
                    </h6>
                    <p style={{ fontSize: "16px", margin: 0 }}>
                      {user.address || "N/A"}
                    </p>
                  </div>
                </Col>
                <Col md={3}>
                  <div
                    style={{
                      background: "#f8f9fa",
                      padding: "15px",
                      borderRadius: "12px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <h6 style={{ fontWeight: "600", color: "#7A6FBE" }}>
                      ⭐ Role
                    </h6>
                    <p style={{ fontSize: "16px", margin: 0 }}>{user.role}</p>
                  </div>
                </Col>
              </Row>
              <div className="text-center mt-3">
                <Button
                  color="primary"
                  style={{ backgroundColor: "#7A6FBE", border: "none" }}
                  size="lg"
                  onClick={() => setIsEditing(true)}
                >
                  Edit
                </Button>
              </div>
            </>
          ) : (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>First Name</Label>
                    <Input
                      name="fname"
                      value={form.fname}
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Last Name</Label>
                    <Input
                      name="lname"
                      value={form.lname}
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Email</Label>
                    <Input
                      name="email"
                      type="email"
                      value={form.email}
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Phone</Label>
                    <Input
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Gender</Label>
                    <Input
                      type="select"
                      name="gender"
                      value={form.gender || ""} // ✅ prefilled with current gender
                      onChange={handleChange}
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="Other">Other</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Address</Label>
                    <Input
                      name="address"
                      value={form.address}
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <div className="d-flex justify-content-end gap-2">
                <Button
                  color="success"
                  style={{ backgroundColor: "#7A6FBE", border: "none" }}
                  onClick={handleUpdate}
                >
                  Save
                </Button>
                <Button color="secondary" onClick={() => setIsEditing(false)}>
                  Cancel
                </Button>
              </div>
            </Form>
          )}
        </CardBody>
      </Card>
    </div>
  )
}

export default Profile
